module.exports = __webpack_public_path__ + "img/clinic.a547589b.svg";